import getStore from '../data/store/store';

/**
 * Util to get whether we are saving currently or not.
 */
export default function isSaving(): boolean {
    return getStore().isSaving;
}
